import { getBreakpoint } from "./getBreakpoint";
const aspectMap = {
    'mobile': 2 / 3,
    'tablet': 3 / 2,
    'desktop': 3 / 1
};
export const getAspectRatio = (width) => {
    const breakpoint = getBreakpoint(width);
    return aspectMap[breakpoint];
};
//# sourceMappingURL=getAspectRatio.js.map